/* ==========================================================================
   PDP Custom JS — Keravive Hair Priority Complex
   Rev 2026-07-13b: one-time purchase fix — clear selling_plan when subscribe
   toggle is unchecked so ATC no longer forces a subscription.
   ========================================================================== */

(function() {
  'use strict';

  /* --- Countdown Timer --- */
  function initCountdown() {
    const el = document.querySelector('[data-pdp-countdown]');
    if (!el) return;
    const endDate = new Date(el.dataset.pdpCountdown).getTime();
    const days = el.querySelector('[data-days]');
    const hrs = el.querySelector('[data-hrs]');
    const mins = el.querySelector('[data-mins]');
    const secs = el.querySelector('[data-secs]');
    if (!days || !hrs || !mins || !secs) return;

    function update() {
      const now = Date.now();
      let diff = endDate - now;
      if (diff < 0) diff = 0;
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      days.textContent = String(d).padStart(2, '0');
      hrs.textContent = String(h).padStart(2, '0');
      mins.textContent = String(m).padStart(2, '0');
      secs.textContent = String(s).padStart(2, '0');
    }
    update();
    setInterval(update, 1000);
  }

  /* --- Image Gallery --- */
  function initGallery() {
    const mainImg = document.querySelector('[data-pdp-main-image]');
    const thumbs = document.querySelectorAll('[data-pdp-thumbnail]');
    if (!mainImg || !thumbs.length) return;

    /* Preload all product images to avoid flicker on swipe */
    thumbs.forEach(function(thumb) {
      var img = new Image();
      img.src = thumb.dataset.pdpThumbnail;
    });

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        const src = this.dataset.pdpThumbnail;
        const srcset = this.dataset.pdpSrcset || '';
        mainImg.src = src;
        if (srcset) mainImg.srcset = srcset;
        thumbs.forEach(function(t) { t.closest('.pdp-main-product__thumbnail').classList.remove('is-active'); });
        this.closest('.pdp-main-product__thumbnail').classList.add('is-active');
        var idx = Array.from(thumbDivs).indexOf(this.closest('.pdp-main-product__thumbnail'));
        if (idx >= 0) updateProgress(idx, thumbDivs.length);
      });
    });

    /* Progress bar */
    var progressFill = document.querySelector('[data-pdp-progress-fill]');
    function updateProgress(index, total) {
      if (!progressFill || total < 2) return;
      var pct = ((index + 1) / total) * 100;
      progressFill.style.width = pct + '%';
    }

    /* Scroll thumbnail strip to keep active thumb visible */
    var thumbStrip = document.querySelector('.pdp-main-product__thumbnails');
    function scrollToActiveThumb(index) {
      if (!thumbStrip || !thumbDivs[index]) return;
      var thumb = thumbDivs[index];
      var stripLeft = thumbStrip.scrollLeft;
      var stripWidth = thumbStrip.clientWidth;
      var thumbLeft = thumb.offsetLeft - thumbStrip.offsetLeft;
      var thumbWidth = thumb.offsetWidth;
      if (thumbLeft < stripLeft || thumbLeft + thumbWidth > stripLeft + stripWidth) {
        thumbStrip.scrollTo({ left: thumbLeft - (stripWidth / 2) + (thumbWidth / 2), behavior: 'smooth' });
      }
    }

    /* Thumbnail arrow navigation */
    var thumbArrowLeft = document.querySelector('[data-thumb-arrow="left"]');
    var thumbArrowRight = document.querySelector('[data-thumb-arrow="right"]');
    var thumbDivs = document.querySelectorAll('.pdp-main-product__thumbnail');
    var arrowBusy = false;

    function arrowNav(dir) {
      if (arrowBusy) return;
      arrowBusy = true;
      setTimeout(function() { arrowBusy = false; }, 300);

      var current = 0;
      for (var i = 0; i < thumbDivs.length; i++) {
        if (thumbDivs[i].classList.contains('is-active')) { current = i; break; }
      }
      var next = current + dir;
      if (next < 0) next = thumbDivs.length - 1;
      if (next >= thumbDivs.length) next = 0;

      var img = thumbDivs[next].querySelector('img');
      if (!img) { arrowBusy = false; return; }

      mainImg.src = img.dataset.pdpThumbnail;
      if (img.dataset.pdpSrcset) mainImg.srcset = img.dataset.pdpSrcset;
      for (var j = 0; j < thumbDivs.length; j++) thumbDivs[j].classList.remove('is-active');
      thumbDivs[next].classList.add('is-active');
      updateProgress(next, thumbDivs.length);
      scrollToActiveThumb(next);
    }

    if (thumbArrowLeft) {
      thumbArrowLeft.onclick = function(e) { e.preventDefault(); e.stopPropagation(); arrowNav(-1); };
    }
    if (thumbArrowRight) {
      thumbArrowRight.onclick = function(e) { e.preventDefault(); e.stopPropagation(); arrowNav(1); };
    }

    /* Touch swipe on main image for mobile */
    var imageMain = document.querySelector('.pdp-main-product__image-main');
    if (imageMain) {
      var touchStartX = 0;
      var touchStartY = 0;
      var touchMoved = false;

      imageMain.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].clientX;
        touchStartY = e.changedTouches[0].clientY;
        touchMoved = false;
      }, { passive: true });

      imageMain.addEventListener('touchmove', function(e) {
        var dx = Math.abs(e.changedTouches[0].clientX - touchStartX);
        var dy = Math.abs(e.changedTouches[0].clientY - touchStartY);
        if (dx > dy && dx > 10) {
          touchMoved = true;
          e.preventDefault();
        }
      }, { passive: false });

      imageMain.addEventListener('touchend', function(e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 40 && touchMoved) {
          arrowNav(dx < 0 ? 1 : -1);
        }
      }, { passive: true });
    }

    /* Lightbox */
    const lightbox = document.querySelector('.pdp-lightbox');
    const lightboxImg = lightbox ? lightbox.querySelector('.pdp-lightbox__image') : null;
    const lightboxClose = lightbox ? lightbox.querySelector('.pdp-lightbox__close') : null;
    const mainWrap = document.querySelector('.pdp-main-product__image-main');

    if (mainWrap && lightbox && lightboxImg) {
      mainWrap.addEventListener('click', function() {
        lightboxImg.src = mainImg.src;
        lightbox.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
      if (lightboxClose) {
        lightboxClose.addEventListener('click', function() {
          lightbox.classList.remove('is-open');
          document.body.style.overflow = '';
        });
      }
      lightbox.addEventListener('click', function(e) {
        if (e.target === lightbox) {
          lightbox.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });
    }
  }

  /* --- Bundle Options --- */
  function initBundleOptions() {
    /* Removed — now handled by Kaching Bundle app */
  }

  /* --- Sticky Buy Bar --- */
  function initStickyBar() {
    const bar = document.querySelector('.pdp-sticky-bar');
    const atcBtn = document.querySelector('.pdp-atc-btn');
    if (!bar || !atcBtn) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          bar.classList.remove('is-visible');
        } else {
          bar.classList.add('is-visible');
        }
      });
    }, { threshold: 0 });

    observer.observe(atcBtn);
  }

  /* --- Percentage Counter Animation --- */
  function initCounters() {
    var counters = document.querySelectorAll('[data-pdp-counter]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !entry.target.dataset.counted) {
          entry.target.dataset.counted = 'true';
          var target = parseInt(entry.target.getAttribute('data-pdp-counter-target'), 10) || 0;
          var duration = 1500;
          var startTime = null;

          function animate(timestamp) {
            if (!startTime) startTime = timestamp;
            var progress = Math.min((timestamp - startTime) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            entry.target.textContent = Math.floor(eased * target);
            if (progress < 1) {
              requestAnimationFrame(animate);
            } else {
              entry.target.textContent = target;
            }
          }

          requestAnimationFrame(animate);
        }
      });
    }, { threshold: 0.3 });

    counters.forEach(function(c) { observer.observe(c); });
  }

  /* --- Tab Switching --- */
  function initTabs() {
    var tabBtns = document.querySelectorAll('[data-pdp-tab-btn]');
    if (!tabBtns.length) return;

    tabBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var tabGroup = this.closest('[data-pdp-tabs]');
        if (!tabGroup) return;
        var target = this.dataset.pdpTabBtn;
        tabGroup.querySelectorAll('[data-pdp-tab-btn]').forEach(function(b) { b.classList.remove('is-active'); });
        tabGroup.querySelectorAll('[data-pdp-tab-content]').forEach(function(c) { c.classList.remove('is-active'); });
        this.classList.add('is-active');
        var content = tabGroup.querySelector('[data-pdp-tab-content="' + target + '"]');
        if (content) content.classList.add('is-active');
      });
    });
  }

  /* --- FAQ Accordion — handled by inline script in pdp-faq-accordion.liquid --- */
  function initAccordions() {
    /* No-op: FAQ accordion JS is in the section's inline script to avoid double-binding */
  }

  /* --- Subscribe Checkbox (legacy, no-op if absent) --- */
  function initSubscribe() {
    var checkbox = document.querySelector('.pdp-subscribe-option__checkbox');
    if (!checkbox) return;
    checkbox.addEventListener('click', function() {
      this.classList.toggle('is-checked');
    });
  }

  /* --- Bundle tier selector + Subscribe & Save toggle --- */
  function initBundle() {
    var bundle = document.querySelector('[data-pdp-bundle]');
    if (!bundle) return;

    var tiers = Array.prototype.slice.call(bundle.querySelectorAll('[data-pdp-tier]'));
    if (!tiers.length) return;

    var subWrap = bundle.querySelector('[data-pdp-subscribe]');
    var subInput = bundle.querySelector('[data-pdp-subscribe-input]');
    var hintEl = bundle.querySelector('[data-pdp-sub-hint]');
    var hintTpl = hintEl ? hintEl.getAttribute('data-hint-tpl') : '';

    var form = document.querySelector('[data-pdp-atc-form]');
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var planInput = form ? form.querySelector('[name="selling_plan"]') : null;

    /* Price block (top of buy box) — ensure a compare-price span exists */
    var priceBlock = document.querySelector('.pdp-price-block');
    var currentEl = priceBlock ? priceBlock.querySelector('[data-pdp-current-price]') : null;
    var compareEl = priceBlock ? priceBlock.querySelector('[data-pdp-compare-price]') : null;
    if (priceBlock && currentEl && !compareEl) {
      compareEl = document.createElement('span');
      compareEl.className = 'pdp-price-compare';
      compareEl.setAttribute('data-pdp-compare-price', '');
      currentEl.insertAdjacentElement('afterend', compareEl);
    }

    var selected = tiers.filter(function(t) { return t.classList.contains('is-selected'); })[0] || tiers[0];
    var subscribed = subInput ? subInput.checked : false;

    function render() {
      tiers.forEach(function(t) {
        t.classList.toggle('is-selected', t === selected);

        /* Per-card price reflects the subscribe state (pre-checked = sub price) */
        var tPlan = t.getAttribute('data-plan-id') || '';
        var tSub = subscribed && tPlan !== '';
        var oneTime = parseInt(t.getAttribute('data-price'), 10) || 0;
        var subP = parseInt(t.getAttribute('data-sub-price'), 10) || 0;
        var cmp = parseInt(t.getAttribute('data-compare'), 10) || 0;
        var shown = tSub ? subP : oneTime;

        var pEl = t.querySelector('[data-pdp-tier-price]');
        var cEl = t.querySelector('[data-pdp-tier-compare]');
        var mEl = t.querySelector('[data-pdp-tier-permo]');

        if (pEl) pEl.textContent = tSub ? t.getAttribute('data-sub-price-fmt') : t.getAttribute('data-price-fmt');
        if (cEl) {
          if (cmp > shown) { cEl.textContent = t.getAttribute('data-compare-fmt'); cEl.hidden = false; }
          else if (tSub && oneTime > shown) { cEl.textContent = t.getAttribute('data-price-fmt'); cEl.hidden = false; }
          else { cEl.hidden = true; }
        }
        if (mEl) mEl.textContent = tSub ? t.getAttribute('data-sub-permo-fmt') : t.getAttribute('data-permo-fmt');
      });
      if (subWrap) subWrap.classList.toggle('is-checked', subscribed);

      /* Subscribe hint frequency follows the selected tier */
      if (hintEl && hintTpl) {
        hintEl.textContent = hintTpl.replace('[freq]', selected.getAttribute('data-interval') || 'every month');
      }

      var planId = selected.getAttribute('data-plan-id') || '';
      var canSub = subscribed && planId !== '';

      if (idInput) idInput.value = selected.getAttribute('data-variant-id') || '';
      if (planInput) planInput.value = canSub ? planId : '';

      if (currentEl) {
        currentEl.textContent = canSub
          ? selected.getAttribute('data-sub-price-fmt')
          : selected.getAttribute('data-price-fmt');
      }
      if (compareEl) {
        var selOne = parseInt(selected.getAttribute('data-price'), 10) || 0;
        var selCmp = parseInt(selected.getAttribute('data-compare'), 10) || 0;
        var selShown = canSub ? (parseInt(selected.getAttribute('data-sub-price'), 10) || 0) : selOne;
        if (selCmp > selShown) {
          compareEl.textContent = selected.getAttribute('data-compare-fmt');
          compareEl.style.display = '';
        } else if (canSub && selOne > selShown) {
          compareEl.textContent = selected.getAttribute('data-price-fmt');
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
    }

    tiers.forEach(function(t) {
      t.addEventListener('click', function(e) {
        e.preventDefault();
        if (t.hasAttribute('data-unavailable')) return;
        selected = t;
        render();
      });
    });

    if (subInput) {
      subInput.addEventListener('change', function() {
        subscribed = subInput.checked;
        render();
      });
    }

    render();
  }

  /* --- Add to Cart Form --- */
  function initATC() {
    var form = document.querySelector('[data-pdp-atc-form]');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = form.querySelector('.pdp-atc-btn');
      var btnText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding...';

      var variantId = form.querySelector('[name="id"]').value;
      var qty = parseInt(form.querySelector('[name="quantity"]').value) || 1;
      var planEl = form.querySelector('[name="selling_plan"]');
      var sellingPlan = planEl && planEl.value ? parseInt(planEl.value) : null;

      var item = { id: parseInt(variantId), quantity: qty };
      if (sellingPlan) { item.selling_plan = sellingPlan; }

      /* Get cart-drawer section id for live update */
      var cartDrawer = document.querySelector('cart-drawer');
      var sections = cartDrawer ? [cartDrawer.dataset.sectionId] : [];

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [item],
          sections: sections.join(',')
        })
      })
      .then(function(res) { return res.json(); })
      .then(function(response) {
        btn.textContent = 'Added!';
        setTimeout(function() {
          btn.disabled = false;
          btn.textContent = btnText;
        }, 1500);

        /* Get current cart count and update */
        var cartIcon = document.querySelector('cart-icon');
        var currentCount = cartIcon ? cartIcon.getCurrentItemCount() : 0;
        var newCount = (currentCount || 0) + qty;

        /* Dispatch theme cart:updated event with proper data */
        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: {
              resource: {},
              data: {
                itemCount: newCount,
                source: 'product-form',
                sections: response.sections || {}
              }
            }
          })
        );
      })
      .catch(function() {
        btn.disabled = false;
        btn.textContent = btnText;
      });
    });

    /* Sticky bar — scroll to bundle/main product section */
    var stickyBtn = document.querySelector('.pdp-sticky-bar__btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        var target = document.getElementById('main-product');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  }

  /* --- Scroll to top CTA --- */
  function initScrollCTA() {
    var btns = document.querySelectorAll('[data-pdp-scroll-to]');
    btns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.querySelector(this.dataset.pdpScrollTo);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* --- Scroll-Reveal Animations --- */
  function initScrollReveal() {
    var sections = document.querySelectorAll('.animate-section.animate--hidden');
    if (!sections.length) return;

    /* Check for reduced motion preference */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      sections.forEach(function(section) {
        section.classList.remove('animate--hidden');
        section.classList.add('animate--shown');
      });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.remove('animate--hidden');
          entry.target.classList.add('animate--shown');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    sections.forEach(function(section) {
      observer.observe(section);
    });
  }

  /* --- Init All --- */
  function init() {
    initCountdown();
    initGallery();
    initStickyBar();
    initCounters();
    initTabs();
    initAccordions();
    initSubscribe();
    initBundle();
    initATC();
    initScrollCTA();
    initScrollReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
